interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
}

const ranks: RankItem[] = [
  { rank: 1, title: '剑与魔法', tag: '日漫·热血', heat: '🔥 980万热度' },
  { rank: 2, title: '夏日幻梦 第三季', tag: '日漫·恋爱', heat: '🔥 860万热度' },
  { rank: 3, title: '星域传说', tag: '国漫·科幻', heat: '🔥 750万热度' },
  { rank: 4, title: '契约婚姻', tag: '韩漫·恋爱', heat: '🔥 690万热度' },
  { rank: 5, title: '暗夜追踪者', tag: '日漫·悬疑', heat: '🔥 620万热度' },
  { rank: 6, title: '逆天邪神', tag: '国漫·玄幻', heat: '🔥 580万热度' },
  { rank: 7, title: '长安幻夜', tag: '国漫·古风', heat: '🔥 510万热度' },
];

function getRankBadge(rank: number): string {
  if (rank === 1) return 'bg-accent-500 text-background-50';
  if (rank === 2) return 'bg-primary-500 text-background-50';
  if (rank === 3) return 'bg-secondary-500 text-background-50';
  return 'bg-background-300 text-foreground-600';
}

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Title area */}
          <div className="lg:w-[280px] shrink-0 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              热门榜单
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-6">
              实时热度排行，发现大家都在追的热门动漫
            </p>
            <div className="hidden lg:flex flex-wrap gap-2">
              <span className="inline-block px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap cursor-pointer">日榜</span>
              <span className="inline-block px-3 py-1.5 rounded-full bg-background-200 text-foreground-500 text-xs font-medium whitespace-nowrap cursor-pointer hover:bg-background-300 transition-colors">周榜</span>
              <span className="inline-block px-3 py-1.5 rounded-full bg-background-200 text-foreground-500 text-xs font-medium whitespace-nowrap cursor-pointer hover:bg-background-300 transition-colors">月榜</span>
            </div>
          </div>

          {/* Rank list */}
          <div className="flex-1">
            <div className="space-y-0">
              {ranks.map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-4 py-4 border-b border-background-200/70 last:border-b-0 group cursor-pointer hover:bg-background-100/50 rounded-lg px-3 -mx-3 transition-colors"
                >
                  <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${getRankBadge(item.rank)}`}>
                    {item.rank}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-500">{item.tag}</span>
                  </div>
                  <div className="text-xs md:text-sm text-accent-600 font-medium whitespace-nowrap shrink-0">
                    {item.heat}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}